import React, { useState } from 'react';

import { MappedFulfillment } from './Claim/types';
import { CreateReturnModal } from './CreateReturnModal';
import { InfoTooltip } from './Tooltip';
import { Button } from './buttons/Button';
import { Customer, Order, ProductReturn } from '../pages/types';
import { canStartProductReturn } from '../utils';

interface ReturnsColumnProps {
  productReturn: ProductReturn | undefined;
  customer: Customer;
  order: Order;
  products: MappedFulfillment[];
}

const ProductReturnStatus = ({ productReturn }: { productReturn: ProductReturn }) => {
  const productReturnStatus = productReturn?.status.toLocaleLowerCase();

  const productReturnStatusColor = (productReturnStatus?: string) => {
    if (!productReturnStatus) return '';
    switch (productReturnStatus) {
      case 'processed':
        return 'text-[#008C1E]';
      case 'expired':
        return 'text-gray';
      default:
        return '';
    }
  };

  return (
    <div
      className={`flex flex-col text-center items-center ${productReturnStatusColor(
        productReturnStatus
      )}`}
    >
      <div className="flex flex-row items-center gap-1">
        <span className="text-sm">Return {productReturnStatus}</span>
        {productReturnStatus === 'expired' && (
          <InfoTooltip
            width="12"
            height="12"
            text="Customer did not drop off their return shipment within 90 days"
          />
        )}
      </div>
      {productReturnStatus === 'pending' && !productReturn.label_url && (
        <p className="text-xs">Return label generating...</p>
      )}
      {productReturnStatus === 'pending' && productReturn.label_url && (
        <a className="text-xs underline hover:cursor-pointer" href={productReturn.label_url}>
          Link to return label
        </a>
      )}
    </div>
  );
};

export const ReturnsColumn = ({ productReturn, customer, order, products }: ReturnsColumnProps) => {
  const [showCreateReturnModal, setShowCreateReturnModal] = useState(false);

  if (!canStartProductReturn(order)) {
    return productReturn ? <ProductReturnStatus productReturn={productReturn} /> : '--';
  }

  return (
    <div className="flex items-center justify-center">
      {showCreateReturnModal && (
        <CreateReturnModal
          customer={customer}
          orderId={order.id}
          products={products}
          onCancel={() => setShowCreateReturnModal(false)}
        />
      )}
      {productReturn ? (
        <ProductReturnStatus productReturn={productReturn} />
      ) : (
        <Button
          label="Start a Return"
          onClick={() => setShowCreateReturnModal(true)}
          className="px-[2px] py-[2px]"
          variant="secondary"
          textClassName="text-sm font-normal"
        />
      )}
    </div>
  );
};
